
function loadVideoSource() {
  let $videoContainer = $('#bannerVideoDesktop');
  let videoUrl = $videoContainer.attr('data-src');
  $('#bannerVideoDesktop source').attr('src', videoUrl);
  $videoContainer[0].load();
  $videoContainer[0].play();

}

function loadSliders() {
  if($('.js-mission-slider').length) {
    $('.js-mission-slider').slick({
      mobileFirst: true,
      dots:true,
      arrows: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick'
        }
      ]
    });
  }
  if( $(".js-sustainable-carousel").length) {
    $(".js-sustainable-carousel").slick({
      autoplay:false,
      dots:false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }
      ]
    });
  }
  if( $(".js-step-carousel").length) {
    $(".js-step-carousel").slick({
      autoplay:false,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        },
        {
          breakpoint: 799,
          settings: 'unslick'
        }
      ]
    });
  }
}
$(window).on('load', function () {
  loadVideoSource()
  loadSliders()
});

$(document).ready(function(e){

  /*
  $('.js-goTo').on('click', function(e) {
    let target = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(target).offset().top - 50
  }, 800);
  });
  */

  const mq = window.matchMedia( "(min-width: 768px)" );
  var parallaxScrollBuffer = 250;
  var parallaxStarts = [],  parallaxStarts2 = [];
  $('.paraEl').each(function() {
    var start = $(this).offset().top - parallaxScrollBuffer;
    parallaxStarts.push(start);
  });

  $('.paraEl-bt').each(function() {
    var start = $(this).offset().top - 400;
    parallaxStarts2.push(start);
  });

  $(window).scroll(function() {
    if (mq.matches) {
      for (var i = 0; i < parallaxStarts.length; i++) {
        if ($(this).scrollTop() >= parallaxStarts[i]) {
          $('.paraEl').eq(i).css({
            'bottom': -(($(this).scrollTop() - parallaxStarts[i]) / 2) + "px"
          });
        }
      }

      for (var i = 0; i < parallaxStarts2.length; i++) {
        if ($(this).scrollTop() >= parallaxStarts2[i]) {
          $('.paraEl-bt').eq(i).css({
            'bottom': (($(this).scrollTop() - parallaxStarts[i]) / 2) + "px"
          });
        }
      }
    }
  });

});
